import VxeTextareaComponent from './src/textarea';
import { dynamicApp } from '../dynamics';
export var Textarea = Object.assign(VxeTextareaComponent, {
    install: function (app) {
        dynamicApp.component(VxeTextareaComponent.name, VxeTextareaComponent);
        app.component(VxeTextareaComponent.name, VxeTextareaComponent);
    }
});
export default Textarea;
